 
import { wrapRequest } from './nav';
const vueAppNeonApiUrl = import.meta.env.VITE_NEON_DB_API_URL;

export const doFetchOne= wrapRequest((id) => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-type': 'application/json'},
    };
    return fetch(`${vueAppNeonApiUrl}/design_project/${id}`, requestOptions);    
});
